import { ref, computed } from 'vue'
import { authFetch, BASE_URL } from '@/api/client'

export interface CurrentUser {
  userId: string
  email: string
  name: string
  roles: string[]
  permissions: {
    manageTemplate: boolean
    editPrograms: boolean
    approvePrograms: boolean
  }
}

const me = ref<CurrentUser | null>(null)
const loaded = ref(false)

/** Highest role for display: Admin > Contributor > Viewer > No Role */
const roleLabel = computed(() => {
  const roles = me.value?.roles || []
  if (roles.includes('RAT-Admins')) return 'Admin'
  if (roles.includes('RAT-Contributors')) return 'Contributor'
  if (roles.includes('RAT-Viewers')) return 'Viewer'
  return 'No Role'
})

const roleColor = computed(() => {
  switch (roleLabel.value) {
    case 'Admin': return '#43A047'
    case 'Contributor': return '#1E88E5'
    case 'Viewer': return '#78909C'
    default: return '#E53935'
  }
})

async function loadCurrentUser(): Promise<void> {
  try {
    const res = await authFetch(`${BASE_URL}/v1/me`)
    if (res.ok) {
      me.value = (await res.json()).data
    }
  } catch {
    // Leave me null — UI falls back to "No Role"
  } finally {
    loaded.value = true
  }
}

export function useCurrentUser() {
  return { me, loaded, roleLabel, roleColor, loadCurrentUser }
}
